import * as React from 'react'
import styled from 'styled-components'

const StyledPage = styled.div``

interface PageProps {
  className?: string
}

const Page: React.SFC<PageProps> = ({ children, className }) => <StyledPage className={className}>{children}</StyledPage>

export default Page
